import { type Ref, watch } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import type UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import AbstractSignupScreen from './AbstractSignupScreen';

export default class SignupSubmittingSignupScreen extends AbstractSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-signup-form-submitting';

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    isBackButtonHidden: Ref<boolean>;
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
  }

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public getProgress(): number {
    return 90;
  }

  public predicate(): boolean {
    return this.sessionInfo.value.formSubmitStatus === 'submitting';
  }

  public async toNextScreen(): Promise<boolean> {
    await this.pollFormSubmitting();
    return true;
  }

  private async pollFormSubmitting() {
    let interval: ReturnType<typeof setInterval> | null = null;
    let _res: ((_value: null) => void) | null = null;

    watch(
      this.sessionInfo,
      (newVal) => {
        console.log(
          'SignupSubmittingSignupScreen observed sessionInfo change, formSubmitStatus:',
          newVal.formSubmitStatus,
          _res ? 'res is set' : 'res is not set',
          interval ? 'interval is set' : 'interval is not set'
        );

        if (!_res || interval == null) return;

        if (
          newVal.formSubmitStatus === 'submitted' ||
          newVal.formSubmitStatus === 'submit-failed'
        ) {
          _res(null);
          clearInterval(interval);
        }
      },
      {
        once: true,
      }
    );

    await new Promise((res) => {
      _res = res;
      interval = setInterval(() => {
        const { formSubmitStatus } = this.sessionInfo.value;

        console.log('Polling submission status:', formSubmitStatus);
        if (formSubmitStatus === 'submitted' || formSubmitStatus === 'submit-failed') {
          clearInterval(interval as ReturnType<typeof setInterval>);
          res(null);
        }
      }, 1000);
    });
  }
}
